<template>
    <a href="javascript:" ondragstart="return false"
       :class="'btn ' + (hide ? 'btn-hind' : 'btn-hollow-dark')"
       @click="!hide && handleClick()"
    ><slot></slot></a>
  </template>
<script>
  export default {
    name: 'grid-top-menu',
    props: {
      hide: {
        type: Boolean,
        default() {
          return false
        }
      }
    },
    methods: {
      handleClick() {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-top-menu.vue